import { Controller } from '@hotwired/stimulus';

// Charge de travail : formulaire GET envoyé à la Frame « workload » dès qu'une
// liste change ; par clients ou par inspecteur, l'autre liste est vidée.
const clear = (select) => select.dispatchEvent(new CustomEvent('combobox:clear', { bubbles: true }));

export default class extends Controller {
    static targets = ['customers', 'technician'];

    byCustomers() {
        clear(this.technicianTarget);
        this.element.requestSubmit();
    }

    byTechnician() {
        clear(this.customersTarget);
        this.element.requestSubmit();
    }
}
